import { render, staticRenderFns } from "./jxfw.vue?vue&type=template&id=5112472f&scoped=true"
import script from "./jxfw.vue?vue&type=script&lang=js"
export * from "./jxfw.vue?vue&type=script&lang=js"
import style0 from "./jxfw.vue?vue&type=style&index=0&id=5112472f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5112472f",
  null
  
)

export default component.exports